import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Play, Clock } from 'lucide-react';

interface ResumeLessonProps {
  lastDegree: {
    class_id: string;
    name: string;
    current_unit: number;
    current_lesson: number;
    title?: string;
  } | null;
}

const UNI_GOLD = '#d4a843';
const UNI_BORDER = 'rgba(255,255,255,0.08)';
const UNI_CARD = 'rgba(255,255,255,0.06)';

const ResumeLessonCard: React.FC<ResumeLessonProps> = ({ lastDegree }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!lastDegree) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ scale: 1.01, borderColor: 'rgba(212,168,67,0.3)' }}
      onClick={() => navigate(`/university/learn/${lastDegree.class_id}?module=${lastDegree.current_unit}&lesson=${lastDegree.current_lesson}`)}
      style={{
        background: `linear-gradient(90deg, ${UNI_CARD}, rgba(212,168,67,0.05))`,
        border: `1px solid ${UNI_BORDER}`,
        borderRadius: 20,
        padding: '20px 24px',
        marginBottom: '24px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 20,
        transition: 'all 0.2s'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <div style={{ 
          width: 48, height: 48, borderRadius: 14, 
          background: `linear-gradient(135deg, ${UNI_GOLD}, #b8912e)`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 4px 15px rgba(212,168,67,0.2)'
        }}>
          <Play size={20} color="#06060c" fill="#06060c" />
        </div>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
            <Clock size={12} color={UNI_GOLD} />
            <span style={{ fontSize: 11, fontWeight: 700, color: UNI_GOLD, letterSpacing: '1px' }}>
              {t('university.dashboard.resumeLabel', 'CONTINUE LEARNING')}
            </span>
          </div>
          <h3 style={{ fontSize: 16, fontWeight: 700, color: '#fff', margin: 0 }}>
            {lastDegree.name.replace('BSc ', '')}
          </h3>
          <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.45)', margin: '2px 0 0' }}>
            Module {lastDegree.current_unit} · Lesson {lastDegree.current_lesson}
          </p>
        </div>
      </div>

      <motion.div
        whileHover={{ x: 5 }}
        style={{ color: UNI_GOLD, fontSize: 14, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}
      >
        {t('university.dashboard.resumeBtn', 'Resume')} <Play size={14} fill={UNI_GOLD} />
      </motion.div>
    </motion.div>
  );
};

export default ResumeLessonCard;
